module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-7aa2320a381e48421f36f4c6a54ebd59.svg";